import { format, isValid, parseISO } from "date-fns";
const parseTimePoint = (date, time) => {
    if (!date || !time)
        return undefined;
    const parsed = parseISO(`${date}T${time}`);
    if (!isValid(parsed))
        return undefined;
    return { date, time: format(parsed, "HH:mm") };
};
export const getTournamentTimeRange = (group) => {
    if (!group)
        return {};
    const start = parseTimePoint(group.start, group.arenaStart);
    const end = parseTimePoint(group.end, group.arenaEnd);
    return {
        start: start && { date: start.date, time: start.time },
        end: end && { date: end.date, time: end.time },
    };
};
//# sourceMappingURL=tournamentTimeRange.js.map